<ul>
    {{each data}}
    <li>
        <div class="li-hover">
            <div class="learn-li-box">
                <span><img src="{{$value.logo}}" alt=""></span>
                <div class="learn-list-detail">
                    <h4>{{$value.name}}</h4>
                    <p>{{$value.phone}}</p>
                    <p>{{$value.email}}</p>
                </div>
            </div>
            <a href="{{$value.url}}" class="look-detail">查看详情</a>
        </div>
    </li>
    {{/each}}
</ul>